<form [formGroup]="properties.formGroup" class="d-flex fd-col login-form">
  <ng-container *ngFor="let controlGroup of formModelArray">
    <div class="d-flex control-group mb-12" [ngClass]="
        controlGroup.length > 1 ? 'fd-row gap-10-px pt-field-8-px' : 'fd-col'
      ">
      <ng-container *ngFor="let control of controlGroup">
        <div formGroupName="{{ control.formName }}" class="mat-input d-flex fd-row align-items-center"
          *ngIf="!control.hiddenControl || handleHideFromParent(control)" [ngClass]="{
            'observation-last-control': control.formKey === 'observation',
            'height-auto': _isAValidControl(control)
          }">
          <ng-container
              *ngIf="_isAMaterialField(control) || ((  control.type) === inputTypeEnum.SELECT && control.list )">
            <mat-form-field appearance="outline" class="height-auto" [ngClass]="{
              'error-field': _isAValidControl(control),
              'disabled-control': control.formControl.options.disabled
            }">
              <mat-label *ngIf="!control.hiddenLabel" class="text-white main-label">{{ control.label }}</mat-label>
              <ng-container *ngIf="control.type">
                <ng-container *ngIf="control.type === inputTypeEnum.INPUT">
                  <ng-container *ngIf="
                    control.formKey === inputTypeEnum.LOCATION_INPUT;
                    else defaultInput
                  ">
                    <input #addresstext id="location-controller-element" matInput
                      formControlName="{{ control.formKey }}" />
                    <location-control-from-api [properties]="locationControlModel"></location-control-from-api>
                  </ng-container>

                  <ng-template #defaultInput>
                    <input matInput formControlName="{{ control.formKey }}"/>
                  </ng-template>
                </ng-container>

                <ng-container *ngIf="control.type === inputTypeEnum.SELECT">
                  <mat-select formControlName="{{ control.formKey }}">
                    <mat-option *ngFor="let item of control.list" [value]="item.value">
                      {{ item.name }}
                    </mat-option>
                  </mat-select>
                </ng-container>

                <ng-container *ngIf="control.type === inputTypeEnum.AUTOCOMPLETE_INPUT">
                  <!-- <autocomplete-control [formGroupInstance]="
                    properties.formGroup.get(control.formName)
                  " [formControlInstance]="
                    properties.formGroup
                      .get(control.formName)
                      .get(control.formKey)
                  " [controlModel]="control" [controlList]="control.list">
                </autocomplete-control> -->
                  <input disabled class="hidden-input" matInput />
                </ng-container>
                <ng-container *ngIf="control.type === inputTypeEnum.CHIP">
                  <sit-chips formControlName="{{ control.formKey }}" [placeholder]="control.label" [required]="true"
                    [options]="control.list"></sit-chips>
                </ng-container>

                <ng-container *ngIf="control.type === inputTypeEnum.INPUT_NUMBER">
                  <input type="number" matInput formControlName="{{ control.formKey }}" />
                </ng-container>

                <ng-container *ngIf="control.type === inputTypeEnum.TEXT">
                  <textarea matInput formControlName="{{ control.formKey }}"></textarea>
                </ng-container>

                <ng-container *ngIf="control.type === inputTypeEnum.DATE">
                  <div class="date">
                    <input id="incidentForm-{{ control.formKey }}" type="date" matInput
                      formControlName="{{ control.formKey }}" />
                  </div>
                </ng-container>

                <ng-container *ngIf="control.type === inputTypeEnum.DATETIME">
                  <div class="date">
                    <input matInput [ngxMatDatetimePicker]="picker" formControlName="{{ control.formKey }}">
                    <mat-datepicker-toggle matSuffix [for]="$any(picker)"></mat-datepicker-toggle>
                    <ngx-mat-datetime-picker #picker [showSeconds]="true">
                    </ngx-mat-datetime-picker>
                  </div>
                </ng-container>

                <ng-container *ngIf="control.type === inputTypeEnum.TIME">
                  <input id="incidentForm-{{ control.formKey }}" type="time" matInput
                    formControlName="{{ control.formKey }}" />
                </ng-container>

                <ng-container *ngIf="control.type === inputTypeEnum.TOOGLESWITCH">
                  <div class="d-flex fd-col">
                    <input class="hidden-control" matInput formControlName="{{ control.formKey }}" />
                    <mat-label class="text-white">{{ control.label }}</mat-label>
                    <state-toogle [formControlInstance]="
                  properties.formGroup
                    .get(control.formName)
                    .get(control.formKey)"></state-toogle>
                  </div>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="control.formControl.validators" ngProjectAs="mat-error">
                <ng-container *ngFor="
                  let validator of control.formControl.validators;
                  let i = index
                ">
                  <ng-container *ngIf="
                    properties.formGroup
                      .get(control.formName)
                      .get(control.formKey)
                      .hasError(validator.validatorCodeName) &&
                    properties.formGroup
                      .get(control.formName)
                      .get(control.formKey).touched
                  ">
                    <mat-error *ngIf="
                      object.keys(
                        properties.formGroup
                          .get(control.formName)
                          .get(control.formKey).errors
                      )[0] === validator.validatorCodeName
                    ">
                      {{ validator.errorMessage }}
                    </mat-error>
                  </ng-container>
                </ng-container>
              </ng-container>
            </mat-form-field>

          </ng-container>

          <ng-container *ngIf="control.type === inputTypeEnum.ACTION_BUTTON">
            <button>Action button</button>
          </ng-container>
          <ng-container
            *ngIf="control.type === inputTypeEnum.BUTTON_RADIO ">
            <div class="d-flex fd-col gap-10-px mb-12">

              <mat-label class="text-white text-weight-500 text-size-18">{{ control.label }}</mat-label>
              <div class="d-inline-flex">
                <ng-container *ngFor="let item of control.list; let i = index">

                  <div class="button-radio">
                    <input formControlName="{{ control.formKey }}" id="btn-{{control.formKey}}-{{i}}"
                      class="hidden-radio" type="radio" [value]="item.value" />
                    <label for="btn-{{control.formKey}}-{{i}}" class="button-label text-size-16">{{ item.name }}</label>
                  </div>

                </ng-container>
              </div>
            </div>

            <ng-container *ngIf="control.formControl.validators" ngProjectAs="mat-error">

              <ng-container *ngFor="let validator of control.formControl.validators">
                <mat-error *ngIf="getControl(control).hasError(validator.validatorCodeName)
                    && getControl(control).touched
                    && object.keys(getControl(control).errors)[0] === validator.validatorCodeName">
                  {{ validator.errorMessage }}
                </mat-error>
              </ng-container>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="control.type === inputTypeEnum.BUTTON_CHECKBOX">
            <div class="d-flex fd-col gap-10-px mb-12">

              <select multiple class="hidden-control" formControlName="{{ control.formKey }}">
                <ng-container *ngFor="let item of control.list; let i = index">
                  <option [value]="item.value">{{ item.name }}</option>
                </ng-container>
              </select>

              <mat-label class="text-white text-weight-500 text-size-18">{{ control.label }}</mat-label>
              <div class="d-inline-flex">

                <ng-container *ngFor="let item of control.list; let i = index">
                  <div class="button-checkbox">
                    <input id="btn-{{control.formKey}}-{{i}}" class="hidden-checkbox" type="checkbox"
                      [value]="item.value" (change)="updateSelection(control, $event, item)"
                      [checked]="selectedCheck(control, item)" />
                    <label for="btn-{{control.formKey}}-{{i}}" class="button-label text-size-16">{{ item.name }}</label>
                  </div>
                </ng-container>

              </div>
            </div>

          </ng-container>

        </div>
      </ng-container>
    </div>
  </ng-container>
</form>

<ng-container *ngIf="properties.actionPanel$ | async as action">
  <div *ngIf="
      action === 'edit' && properties.panelOnManagement === 'manage-incidents'
    ">
    <div class="bg-color-background-1 d-flex mt-2">
      <div class="left-subtitle-block bg-color-primary-1"></div>
      <div class="d-flex full-width py-05">
        <sit-icon alt="Obserción" [icon]="Icon.edit_w" class="text-blue-1 ml-28"
          [sizeClass]="'icon-size-24'"></sit-icon>
        <h2 class="flex-grow text-weight-600 text-size-18 ml-16 text-md-size-18 text-white align-self-center m-0">
          Bitácora
        </h2>
      </div>
    </div>

    <div class="bitacora-observation overflow-y-auto custom-scrollbar" tabindex="0">
      <ng-container *ngFor="let item of observationsList">
        <div class="textWhite observation">
          <!-- <label>Usuario: {{item.authorName ?? 'No especificado'}}</label> -->
          <p>
            <strong>Fecha: {{ formatDate(item?.date) }}, Hora: {{ formatTime(item?.date) }}</strong>
            {{ item.observation }}
          </p>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
